<template>
    <div style="margin: auto">
      <top-bar></top-bar>
      <div style="min-height: 500px;margin: 0 0 80px 0;">
        <top-banner></top-banner>
        <div style="height: 40px;"></div>
        <solution></solution>
        <div style="height: 40px;"></div>
        <recommend-service></recommend-service>
        <div style="height: 40px;"></div>
        <recommend-topic></recommend-topic>
        <div style="height: 40px;"></div>
        <resource></resource>
        <div style="height: 40px;"></div>
        <recommend-org></recommend-org>
        <recommend-unit></recommend-unit>
      </div>
      <div class="top-divider"></div>
      <home-ads></home-ads>
      <div class="top-divider"></div>
      <div>
      </div>
      <help></help>
      <bottom-footer></bottom-footer>
      <floating-menu></floating-menu>
    </div>
</template>

<script>

import TopBar from '../mian-page/topBar'
import bottomFooter from '../mian-page/bottomFooter'
import FloatingMenu from '../mian-page/floatingMenu'
import Help from '../mian-page/help'
import TopBanner from './topBanner'
import Resource from './resource'
import Solution from './solution'
import RecommendService from './recommendService'
import RecommendTopic from './recommendTopic'
import RecommendOrg from './recommendOrg'
import RecommendUnit from './recommendUnit'
import HomeAds from './homeAds'

export default {
  name: 'index',
  components: { HomeAds, RecommendUnit, RecommendOrg, RecommendTopic, RecommendService, Solution, Resource, TopBanner, TopBar, FloatingMenu, bottomFooter, Help }
}
</script>

<style lang="scss" scoped>
  .img-auth{
    text-align: center;
    height: 100px;
    background-color: #fff;
    padding: 20px;
    img{
      height: 100%;
      margin-right: 80px;
    }
  }
</style>
